//Copied and adjusted for AB test, has to be cleaned up afterwards
import React, { useMemo, useRef, useState } from 'react'
import { DSIHtml } from 'shared'
import useResizeObserver from 'use-resize-observer'
export const AbDescription = ({ description }: { description: string }) => {
  const [overflowing, setOverflowing] = useState<boolean | null>(null)
  const [isExpanded, setIsExpanded] = useState(false)
  const wrapperRef = useRef<null | HTMLDivElement>(null)
  const lineHeight = 22.8833
  const collapsedHeight = lineHeight * 12

  useResizeObserver({
    ref: wrapperRef,
    onResize: ({ height }) => {
      if (!wrapperRef.current || !height) return
      setOverflowing(wrapperRef.current.scrollHeight > collapsedHeight)
    },
  })

  // To decide if truncation will be needed one must apply it first.
  // If it isn't needed, we can remove it and return "inherit".
  // If it is needed we keep the calculated height.
  const height = useMemo(() => {
    if (!overflowing || isExpanded) return 'initial'
    return collapsedHeight
  }, [collapsedHeight, isExpanded, overflowing])

  return (
    <>
      <div className="overflow-hidden relative" ref={wrapperRef} style={{ height }}>
        <DSIHtml value={description} />
        {overflowing && !isExpanded && <Fader lineHeight={lineHeight} />}
      </div>
      {overflowing && !isExpanded && (
        <button className="simulated-link mt-3" onClick={() => setIsExpanded(true)}>
          {I18n.t('misc.read_more')}
        </button>
      )}
    </>
  )
}

const Fader = ({ lineHeight }: { lineHeight: number }) => (
  <div
    className="absolute bottom-0 left-0 w-full z-10"
    style={{
      height: `${lineHeight}px`,
      backgroundImage: 'linear-gradient(to bottom, #ffffff00, #ffffffff 90%)',
      boxShadow: 'inset 0 -10px 10px -10px white',
    }}
  />
)
